import { render, staticRenderFns } from "./Scenarios.vue?vue&type=template&id=2871f770&"
import script from "./Scenarios.vue?vue&type=script&lang=js&"
export * from "./Scenarios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports